'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidTime = function IoAndroidTime(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20.1 3.4c9.2 0 16.7 7.5 16.7 16.6s-7.4 16.6-16.7 16.6-16.6-7.5-16.6-16.6 7.4-16.6 16.6-16.6z m0 29.9c7.4 0 13.3-6 13.3-13.3s-5.9-13.3-13.3-13.3-13.2 6-13.2 13.3 5.9 13.3 13.2 13.3z m0.9-21.6v8.7l7.5 4.4-1.2 2.1-8.8-5.3v-9.9h2.5z' })
        )
    );
};

exports.default = IoAndroidTime;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-time.js
// module id = 2152
// module chunks = 0